import { defineStore } from 'pinia'
import {Ref, ref} from 'vue'

export const useInquiryStore = defineStore('inquiry', () => {
    const formData = ref({
        firstName: '',
        lastName: '',
        telephone: '',
        email: '',
        message: '',
        dateFrom: null,
        dateTo: null,
    })

    const singleYachtForm = ref({
        firstName: '',
        lastName: '',
        telephone: '',
        email: '',
        message: '',
        dateFrom: null,
        dateTo: null,
    })

    const multiYachtForm = ref({
        firstName: '',
        lastName: '',
        telephone: '',
        email: '',
        message: '',
        dateFrom: null,
        dateTo: null,
    })

    function resetForm(form: Record<string, any>) {
        if (!form) return;
        form.firstName = '';
        form.lastName = '';
        form.telephone = '';
        form.email = '';
        form.dateFrom = null;
        form.dateTo = null;
        form.message = '';
    }


    return {
        formData,
        singleYachtForm,
        multiYachtForm,
        resetForm
    }
})
